import {Route, Routes} from 'react-router-dom';
import './css/App.css';
import Main from "./bas/Main";
import Login from "./bas/Login";
import Chat from "./bas/Chat";
import Payment from "./bas/Payment";
import Admin from "./bas/Admin";
import GroupChat from "./bas/GroupChat";
import Schedule from "./bas/Schedule";
function App() {

    return (
        <>
            <div className="app-container">
                <div className="content-container">
                    <Routes>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/" element={<Main/>}/>
                        <Route path="/chat" element={<Chat/>}/>
                        <Route path="/payment" element={<Payment/>}/>
                        <Route path="/admin" element={<Admin/>}/>
                        <Route path="/rooms" element={<GroupChat/>}/>
                        <Route path="/schedule" element={<Schedule/>}/>
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default App;
